module.exports = __webpack_public_path__ + "20260508d160511t/img/newhands-icon.2d9c01eb.png";